import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { triggerTransition } from '@uirouter/redux';
import { selectChildEventAndContinue, setSelectedEventTimeObject, getEventTimes } from '../../series/actions/event-series';
import NextAvailableTimeButton from '../../series/components/NextAvailableTimeButton';
import KioskLayoutContainer from './KioskLayoutContainer';
import { getSeriesConfig } from '../../../selectors/ui';
import { getMainEvent } from '../../../selectors/event';
import { getLowInventoryMessage, getSoldOutMessage, getEventTimeFormatted } from '../../series/selectors/eventSeries';
import KioskSeriesTimes from './KioskSeriesTimes';
import { isValidDateObject } from '../../../../helpers/time';
import { createLoadingSelector } from '../../../selectors/helpers';

class KioskTimePicker extends Component {


    componentDidMount() {
        if (this.props.mainEventId && isValidDateObject(this.props.selectedDateObject)) {
            this.props.getEventTimes(this.props.mainEventId, this.props.selectedDateObject);
        }
    }

    onEventSelected = (e) => {
        let id = +e.currentTarget.value;
        this.props.eventTimes.map(eventTime => {
            if (id === +eventTime.id && eventTime.eventStatus == 'on_sale') {
                this.props.selectChildEventAndContinue(id);
                this.props.setSelectedEventTimeObject(eventTime);
            }
        })
    };

    onChangeDate = () => {
        this.props.triggerTransition('seriesDatePicker');
    }

    render() {
        return (
            <KioskLayoutContainer>
                <div className="kiosk__body--full kiosk__body--transparent">
                    <NextAvailableTimeButton />
                    <KioskSeriesTimes
                        selectedDate={this.props.selectedDate}
                        eventTimes={this.props.eventTimes}
                        locale={this.props.locale}
                        getSoldOutMessage={this.props.getSoldOutMessage}
                        getLowInventoryMessage={this.props.getLowInventoryMessage}
                        getEventTimeFormatted={this.props.getEventTimeFormatted}
                        onEventSelected={this.onEventSelected}
                        onChangeDate={this.onChangeDate}
                        showSoldOut={this.props.showSoldOut}
                        loading={!!this.props.loading}
                    />
                </div>
            </KioskLayoutContainer>
        );
    }
}

const eventTimesLoading = createLoadingSelector("EVENT_TIMES");
const mapStateToProps = (state) => {
    let showSoldOut = getSeriesConfig(state).showSoldOut;
    let eventTimes = state.eventSeries.eventTimes.filter(event => {
        return showSoldOut ? event.eventStatus !== "post_sale" : event.eventStatus !== "post_sale" && event.eventStatus !== "sold_out";
    });
    return {
        locale: state.intl.locale,
        eventTimes,
        selectedDateObject: state.eventSeries.selectedDateObject,
        selectedDate: state.eventSeries.selectedDate,
        showSoldOut,
        getLowInventoryMessage: getLowInventoryMessage(state),
        getSoldOutMessage: getSoldOutMessage(state),
        getEventTimeFormatted: getEventTimeFormatted(state),
        mainEventId: getMainEvent(state)?.event?.event_id,
        loading: eventTimesLoading(state),
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        selectChildEventAndContinue,
        triggerTransition,
        setSelectedEventTimeObject,
        getEventTimes,
    }, dispatch);
};

KioskTimePicker.propTypes = {
};

export default connect(mapStateToProps, mapDispatchToProps)(KioskTimePicker)
